







import { Component, Vue } from 'vue-property-decorator'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'
import DropDown from '~components/utils/DropDown.vue'

@Component({
  components: {
    RessortTitle,
    DropDown,
  },
})
export default class VorteilsclubHeader extends Vue {
  public current: string = 'Alle Vorteile'

  private vorteilsCategories: { [key: string]: string } = {
    'Alle Vorteile': 'vorteilsclub',
    Gewinnspiele: 'gewinnspiel',
    Dauervorteile: 'dauervorteil',
    Abovorteile: 'abovorteil',
  }

  get categories() {
    return Object.keys(this.vorteilsCategories)
  }

  onChange(e: string) {
    this.current = e
    this.$emit('on-title-action', this.vorteilsCategories[e])
  }
}
